import * as Sentry from '@sentry/react';

import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: { queries: { staleTime: 1000 * 60, retry: 1 } },
    queryCache: new QueryCache({
      onError: (error, query) => {
        Sentry.captureException(error, {
          tags: { source: 'react-query', kind: 'query' },
          extra: { queryKey: query.queryKey },
        });
      },
    }),
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        Sentry.captureException(error, {
          tags: { source: 'react-query', kind: 'mutation' },
          extra: { mutationKey: mutation.options.mutationKey },
        });
      },
    }),
  });
}
